import BaseAPI from './base'

class ExamStoreAPI extends BaseAPI {}

export default new ExamStoreAPI('v1/exam-stores', 'Exam')
